import * as React from 'react';
import { FLOW_PARAM } from './constants/UrlParams';
import { getHashOrQueryParam, getQueryStringFromHash } from './window/WindowUtils';
import { FlowType } from './services/userflow/UserFlowService';
import { ROUTES } from './Routes';
import { Redirect } from 'react-router-dom';

// This component is loaded when the user loads the root route (#/)
// We use a 'flow' URL parameter to redirect to the correct route as this is all that is
// supported with auth0 SDK
const LoginHostedPage: React.StatelessComponent<{}> = () => {
  const flowType = getHashOrQueryParam(FLOW_PARAM) as FlowType;
  let route = '';

  // TODO remove once all mobile users are off the version that uses this param
  if (deprecatedIsRegister()) {
    route = ROUTES.REGISTER_ENTER_USERNAME;
  } else {
    if (flowType === FlowType.login) {
      route = ROUTES.LOGIN;
    } else if (flowType === FlowType.iFrameLogin) {
      route = ROUTES.IFRAME_LOGIN;
    } else if (flowType === FlowType.resetPassword) {
      route = ROUTES.RESET_PASSWORD_ENTER_USERNAME;
    } else if (flowType === FlowType.register) {
      route = ROUTES.REGISTER_ENTER_USERNAME;
    } else if (flowType === FlowType.cookie) {
      route = ROUTES.COOKIE;
    } else if (flowType === FlowType.forgotUsername) {
      route = ROUTES.FORGOT_USERNAME_FIND_CUSTOMER;
    } else {
      route = ROUTES.LOGIN;
    }
  }

  return <Redirect to={route + getQueryStringIfPresent()} />;
};

const getQueryStringIfPresent = () => {
  const queryStringFromHash = getQueryStringFromHash(); // TODO why is the query string in the hash?
  return queryStringFromHash.length > 0 ? '?' + queryStringFromHash : '';
};

// deprecated, we still have this here for backwards compatibility
// due to the mobile app still using this parameter;
// we can only remove this when all users
// update to the latest app
const deprecatedIsRegister = (): boolean => {
  return getHashOrQueryParam('register') === 'true';
};

export { LoginHostedPage };
